import { ArrowRight } from "@/components/Icon"
import React from "react"
import Block from "@/components/Block"
import Flex from "@/components/Flex"
import Box from "@/components/Box"
import Container from "@/components/Container"
import Typography from "@/components/Typography"
import { useTranslation } from "react-i18next"
import Button from "@/components/Button"
import Link from "@/components/Link"

export const LearnMoreSection = () => {
  const { t } = useTranslation("security")
  return (
    <>
      <Block variant="hero" bg="#F7F9FA">
        <Container>
          <Flex flexDirection={"column"} alignItems="center">
            <Typography
              textAlign={"center"}
              variant="p"
              color={"#0B1426"}
              fontSize={[32, 21, 32]}
              fontWeight={600}
              lineHeight={["125%", "130%"]}
              mb={3}
              maxWidth={[343, "100%"]}
            >
              {t("section_five.title")}
            </Typography>
            <Flex
              mb={[4, 2, 4]}
              flexDirection={["column", "row", "row"]}
              customCss={{ gap: ["30px", 2, "30px"] }}
            >
              {contenthubArticles.map(({ title, link, imgSrc }) => (
                <Link href={link} isExternal key={title}>
                  <Flex
                    flexDirection={"column"}
                    padding={["20px", "12px", "20px"]}
                    borderRadius={"16px"}
                    customCss={{ background: background, boxShadow: boxShadow }}
                    width={[340, 208, 340]}
                  >
                    <Box
                      mb={[3, "12px", 3]}
                      width={[300, 184, 300]}
                      as="img"
                      src={imgSrc}
                      loading="lazy"
                    />
                    <Box minHeight={["unset", "60px", "90px"]}>
                      <Typography
                        variant="p"
                        color="#424242"
                        fontSize={[22, 16, 22]}
                        fontWeight={[600]}
                        lineHeight={["135%", "128%", "135%"]}
                      >
                        {title}
                      </Typography>
                    </Box>
                  </Flex>
                </Link>
              ))}
            </Flex>
            <Flex
              width={"100%"}
              flexDirection={["column", "row"]}
              alignItems={["flex-start", "center"]}
              padding={["32px 40px", "12px 56px", "32px 56px"]}
              borderRadius={"16px"}
              customCss={{ background: background, boxShadow: boxShadow }}
            >
              <Typography
                variant="p"
                color={"#12192B"}
                fontWeight={600}
                fontSize={[24, 16, 24]}
                lineHeight={"145%"}
              >
                {t("section_five.whatToLearn")}
              </Typography>
              <Box ml={[0, "auto"]}>
                <Link isExternal href={`${process.env.MARKET_URL}/university`}>
                  <Button
                    variant="plain"
                    display="flex"
                    alignItems="center"
                    height={["60px", "52px", "60px"]}
                    color={"primaryBrightBlueLightBg"}
                  >
                    <Typography variant="primaryCta" leadingTrim>
                      {t("section_five.buttonCTA")}
                    </Typography>
                    <ArrowRight fontSize="12px" ml={"18px"} />
                  </Button>
                </Link>
              </Box>
            </Flex>
          </Flex>
        </Container>
      </Block>
    </>
  )
}

const contenthubArticles = [
  {
    title: "What is Proof of Reserves",
    link: "https://crypto.com/university/proof-of-reserves",
    imgSrc: `${process.env.ASSETS_BASE_URL}/security-page/learn-more-section/article_1.webp`,
  },
  {
    title: "Protect Your Account With Security & Data Privacy Best Practices",
    link: "https://crypto.com/university/data-privacy-security-best-practices",
    imgSrc: `${process.env.ASSETS_BASE_URL}/security-page/learn-more-section/article_2.webp`,
  },
  {
    title: "How to Recognise Phishing Attempts — With Real-Life Examples",
    link: "https://crypto.com/university/real-life-crypto-phishing-attempts",
    imgSrc: `${process.env.ASSETS_BASE_URL}/security-page/learn-more-section/article_3.webp`,
  },
]

const background =
  "linear-gradient(180deg, rgba(237, 237, 242, 0.5) 0%, rgba(237, 237, 242, 0.5) 100%), #FFFFFF"
const boxShadow =
  "32px 32px 40px rgba(0, 0, 0, 0.05), inset 4px 4px 4px rgba(255, 255, 255, 0.55)"
